// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"36648":"874b7a33785865c8","58486":"d098d3edac61cacc","84756":"102852cdf0c93d47"}[chunkId] + ".css";
};